import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
// import classnames from 'classnames';
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import { LOCALE_PREFIX } from './constants'
import Summary from './components/Summary'
import Table from './components/Table'

import hocConnect from './hocConnect'
import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
@hocConnect
export default class Inspections extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        inspectionsTableChange: PropTypes.func.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    handleTableChange = (changeData) => {
        const { module, block, id, level, customData, inspectionsTableChange } = this.props

        inspectionsTableChange(module, block, id, level, customData, changeData)
    }

    render() {
        const {
            id,
            level,
            data,
            intl: { formatMessage },
        } = this.props

        const transformedLevel = parseInt(level.split(',').slice(-1).pop(), 10)

        return (
            <div className={'inspections-container'}>
                <Summary
                    data={_.get(data, '[0]', {})}
                    translates={{
                        summaryAmountText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.summaryAmountText`} values={{ br: <br /> }} />
                        ),
                        summaryCountText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.summaryCountText`} values={{ br: <br /> }} />
                        ),
                    }}
                />
                {/* {level < 30 && (
                    <div className={'inspections-banner'}>
                        <div className={'text-container'}>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.bannerText`} />
                            </span>
                        </div>
                        <div className={'btn-container'}>
                            <button className={'dialog-button'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.bannerButtonText`} />
                            </button>
                        </div>
                    </div>
                )} */}
                {transformedLevel > 10 && !_.isEmpty(_.get(data, '[1].inspections', {})) && (
                    <Table
                        entityId={id}
                        handleTableChange={this.handleTableChange}
                        translates={{
                            inspectionId: formatMessage({ id: `${LOCALE_PREFIX}.inspectionId` }),
                            address: formatMessage({ id: `${LOCALE_PREFIX}.address` }),
                            inspectionDate: formatMessage({ id: `${LOCALE_PREFIX}.inspectionDate` }),
                            sanction: formatMessage({ id: `${LOCALE_PREFIX}.sanction` }),
                            ban: formatMessage({ id: `${LOCALE_PREFIX}.ban` }),
                            seizure: formatMessage({ id: `${LOCALE_PREFIX}.seizure` }),
                            CZK: formatMessage({ id: `${LOCALE_PREFIX}.CZK` }),
                            EUR: formatMessage({ id: `${LOCALE_PREFIX}.EUR` }),
                        }}
                    />
                )}
            </div>
        )
    }
}
